import { render } from "./SpmFilterInput.vue?vue&type=template&id=27c71986&scoped=true"
import script from "./SpmFilterInput.vue?vue&type=script&lang=ts"
export * from "./SpmFilterInput.vue?vue&type=script&lang=ts"

import "./SpmFilterInput.vue?vue&type=style&index=0&id=27c71986&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27c71986"

export default script